<template>
  <div class="reviewHDDT">
    <div class="header header-before">
      <div class="logo">
        <a href="#"><img src="./img/Nextpay-logo-white.svg" alt="" /></a>
        <h1>Xác nhận thông tin hợp đồng</h1>
      </div>
    </div>

    <div class="main">
      <div class="contract">
        <div class="head-contract table-responsive">
          <table class="table">
            <tr>
              <td align="left">
                <label>CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</label>
                <p>
                  Tầng 12A, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố
                  Hà Nội, Việt Nam.
                </p>
                <p><em>Hotline:1900 2079</em> | <em>Email:hotro@mpos.vn</em></p>
              </td>
              <td align="right">
                <span><img src="@/assets/img/nextpay-logo.svg" alt="" /></span>
              </td>
            </tr>
          </table>
        </div>
        <p class="txt-center fonsize-16 txt-tranf">
          <b>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM </b>
        </p>
        <p class="txt-center fonsize-16"><b>Độc lập – Tự do – Hạnh phúc</b></p>
        <p class="txt-center fonsize-16">***</p>
        <p class="txt-tranf txt-center fonsize-20">
          <b>Hợp đồng cộng tác viên</b>
        </p>
        <p class="txt-center">
          (Số:
          <mark v-if="dataContract.contractAgent && dataContract.contractAgent.codeContract">
            {{ dataContract.contractAgent.codeContract }}
          </mark>
          <mark v-else>...........................................</mark>
          )
        </p>
        <ul class="" style="padding-left: 0; list-style-type: none">
          <li style="list-style: none">
            - Căn cứ vào Bộ Luật Dân sự nước Cộng hòa Xã hội chủ nghĩa Việt Nam và các văn bản sửa
            đổi bổ sung, hướng dẫn thi hành Bộ Luật Dân sự;
          </li>
        </ul>
        <p>Hôm nay, chúng tôi gồm có:</p>
        <p class="fonsize-16 txt-tranf">
          <b v-if="!checkCreatedDateNganluong(dataAppendix)"
            >BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b
          >
          <b v-else>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
        </p>
        <p>
          Địa chỉ: Tầng 12A, tòa nhà VTC online số 18 Đường Tam Trinh, Phường Tương Mai, Thành phố
          Hà Nội, Việt Nam.
        </p>
        <ul class="form">
          <li>Điện thoại: 024.73066696</li>
          <li>Mã số thuế: 0106393463</li>
          <li>
            Đại diện: Ông
            <b
              v-if="
                dataAppendix?.dateSignAppendixDTO ||
                dataAppendix?.dateCreatedAppendixDTO ||
                dataContract?.effectiveFromDTO
                  ? (dataAppendix?.dateSignAppendixDTO ||
                      dataAppendix?.dateCreatedAppendixDTO ||
                      dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                  : new Date() < new Date('2026-01-07')
              "
              >ĐỖ CÔNG DIỄN</b
            >
            <b v-else>NGUYỄN TIẾN LƯỢNG</b>
          </li>
          <li>Chức vụ: <b>Tổng Giám Đốc</b></li>
        </ul>
        <p class="fonsize-16 txt-tranf flex">
          <span> <b>BÊN B: </b></span>
          <mark v-if="dataContract.name"
            ><b>{{ dataContract.name }}</b>
          </mark>
          <mark v-else
            ><b>......................................................................</b>
          </mark>
        </p>
        <p><b>(sau đây được gọi là “BÊN B”)</b></p>
        <p>
          <span>Họ và tên người đại diện: </span>
          <mark v-if="dataContract.name"
            ><b>{{ dataContract.name }}</b></mark
          >
          <mark v-else
            ><b>......................................................................</b></mark
          >
        </p>
        <p>
          <span>Địa chỉ thường trú:</span>
          <mark v-if="dataContract.identity && dataContract.identity.permanentAddress">{{
            dataContract.identity.permanentAddress
          }}</mark>
          <mark v-else
            >.......................................................................................</mark
          >
        </p>
        <p>
          <span>Số CMND/Hộ chiếu/Thẻ căn cước:</span>
          <mark v-if="dataContract.identity && dataContract.identity.idNumber">{{
            dataContract.identity.idNumber
          }}</mark>
          <mark v-else>.............................</mark>
          <span>Nơi cấp:</span>
          <mark v-if="dataContract.identity && dataContract.identity.issueBy">{{
            dataContract.identity.issueBy
          }}</mark>
          <mark v-else>.............................</mark>
          <span>Tại:</span>
          <mark v-if="dataContract.identity && dataContract.identity.issueBy">{{
            dataContract.identity.issueBy
          }}</mark>
          <mark v-else>.............................</mark>
        </p>
        <p>
          <span>Điện thoại:</span>
          <mark v-if="dataContract.mobile">{{ dataContract.mobile }}</mark>
          <mark v-else>.............................</mark>
          <span>Ngày sinh:</span>
          <mark v-if="dataContract.identity && dataContract.identity.dateOfBirth">{{
            dataContract.identity.dateOfBirth | formatDate
          }}</mark>
          <mark v-else>.............................</mark>
        </p>
        <p>&nbsp;</p>
        <p>Thỏa thuận ký kết hợp đồng học việc và cam kết làm đúng những điều khoản sau đây:</p>

        <div class="dieukhoan">
          <label><b>ĐIỀU 1. THỜI HẠN VÀ CÔNG VIỆC HỢP ĐỒNG</b> </label>
          <ul class="dk-list">
            <li>
              - Loại hợp đồng: Cộng tác viên từ ngày {{ dataContract.createdDate | formatDate }}
            </li>
            <li>- Chức danh chuyên môn: {{ dataContract.position }}</li>
            <li>- Nhiệm vụ chính: Thực hiện theo mô tả công việc</li>
          </ul>
        </div>
        <div class="dieukhoan">
          <label><b>ĐIỀU 2. QUYỀN LỢI & NGHĨA VỤ CỦA BÊN B</b> </label>
          <ul class="form-style1" style="counter-reset: none; padding-left: 0; list-style: none">
            <li style="list-style: none">
              <label><b>1. QUYỀN LỢI:</b></label>
              <ul>
                <li>Phương tiện đi lại làm việc: phương tiện cá nhân.</li>
                <li>
                  Mức lương chính hoặc tiền công: là hoa hồng theo chương trình được đính kèm Hợp
                  đồng này.
                </li>
                <li>Thời gian làm việc: Theo yêu cầu công việc</li>
                <li>Thời gian thanh toán thu nhập: Hàng tháng theo chính sách cộng tác viên.</li>
                <li>Hình thức thanh toán thu nhập: Chuyển khoản trước ngày 15 hàng tháng</li>
                <li>Được cấp phát những công cụ, dụng cụ làm việc theo quy định của Bên A.</li>
              </ul>
            </li>
          </ul>
          <ul class="form-style1" style="counter-reset: none; padding-left: 0; list-style: none">
            <li style="list-style: none">
              <label><b>2. NGHĨA VỤ:</b></label>
              <ul>
                <li>
                  Cập nhật thông tin và hỗ trợ đối tác có nhu cầu sử dụng dịch vụ của Bên A lên hệ
                  thống của Bên A cung cấp.
                </li>
                <li>
                  Thực hiện tốt cam kết về nội quy - quy định, cam kết bảo mật thông tin, cam kết
                  đào tạo và những nội dung khác theo quy trình và hướng dẫn của bên A.
                </li>
                <li>
                  Tuyệt đối không sử dụng khách hàng bên A để trục lợi, hoặc làm ảnh hưởng hình ảnh,
                  uy tín của bên A.
                </li>
                <li>
                  Không được cung cấp thông tin, tiết lộ bí mật công nghệ, kỹ thuật, kinh doanh,
                  dịch vụ của bên A ra bên ngoài nếu chưa được sự đồng ý của bên A.
                </li>
                <li>
                  Bồi thường vi phạm và vật chất cho Bên A nếu gây ra sự cố mất mát, hư hỏng hoặc
                  thiệt hại đến các tài sản vật chất và vô hình của Bên A.
                </li>
                <li>Chịu thuế thu nhập cá nhân phát sinh từ Hợp đồng này.</li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="dieukhoan">
          <label><b>Điều 3. QUYỀN HẠN & NGHĨA VỤ CỦA BÊN A</b> </label>
          <ul class="form-style1" style="counter-reset: none; padding-left: 0; list-style: none">
            <li style="list-style: none">
              <label><b>3. QUYỀN HẠN:</b></label>
              <ul>
                <li>
                  Bảo đảm việc làm và thực hiện đầy đủ những điều cam kết trong hợp đồng Cộng tác
                  viên.
                </li>
                <li>
                  Thanh toán đầy đủ, đúng thời hạn các chế độ và quyền lợi cho bên B theo quy định
                  trong hợp đồng Cộng tác viên
                </li>
              </ul>
            </li>
          </ul>
          <ul class="form-style1" style="counter-reset: none; padding-left: 0; list-style: none">
            <li style="list-style: none">
              <label><b>4. NGHĨA VỤ:</b></label>
              <ul>
                <li>
                  Điều hành (bao gồm phân công, bố trí, điều chuyển…) bên B phục vụ mục đích công
                  việc chung tại, ở bất kỳ bộ phận nào trong bên A và tại bất kỳ thời điểm nào trong
                  thời gian hợp đồng này có giá trị.
                </li>
                <li>
                  Yêu cầu bên B thực hiện đúng nếp sống, văn hóa công sở và văn hóa doanh nghiệp.
                </li>
                <li>
                  Tạm hoãn, chấm dứt hợp đồng Cộng tác viên, kỷ luật theo quy định của bên A và của
                  pháp luật.
                </li>
                <li>
                  Khấu trừ thuế thu nhập cá nhân của Bên B để thực hiện đóng thuế thu nhập cá nhân
                  theo Hợp đồng này hộ Bên B.
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="dieukhoan">
          <label><b>ĐIỀU 4. ĐIỀU KHOẢN THI HÀNH</b> </label>
          <ul class="dk-list">
            <li>
              - Những vấn đề về không ghi trong hợp đồng Cộng tác viên này thì áp dụng theo quy định
              của luật Dân sự
            </li>
            <li>
              - Hợp đồng Cộng tác viên này được lập thành 01 bản điện tử gồm chữ ký của các bên được
              lưu trữ trên tài khoản của Bên B trên hệ thống Bên A
            </li>
          </ul>
        </div>
        <div class="table-responsive mt-lg-n3">
          <table class="table" style="border: unset !important">
            <tr>
              <td width="50%" align="center" style="vertical-align: top; border: 0 !important">
                <p style="text-align: center !important">ĐẠI DIỆN BÊN A</p>
                <img
                  v-if="
                    dataAppendix?.dateSignAppendixDTO ||
                    dataAppendix?.dateCreatedAppendixDTO ||
                    dataContract?.effectiveFromDTO
                      ? (dataAppendix?.dateSignAppendixDTO ||
                          dataAppendix?.dateCreatedAppendixDTO ||
                          dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                      : new Date() < new Date('2026-01-07')
                  "
                  src="./img/chuky2.jpg"
                  style="width: 150px; height: 150px; display: inline-block"
                />
                <img
                  v-else
                  src="./img/chuky-moi.png"
                  style="width: 241px; height: auto; display: inline-block"
                />
                <br />
              </td>
              <td width="50%" align="center" style="vertical-align: top; border: 0 !important">
                <br />
                <p style="text-align: center !important">ĐẠI DIỆN BÊN B</p>
                <img
                  v-if="
                    dataContract.contractAgent &&
                    dataContract.contractAgent.linkSignature &&
                    dataContract.contractAgent.linkSignature !==
                      'https://dev-cloud.fastgo.mobi:31888/preview-contract-ctv'
                  "
                  :src="dataContract.contractAgent.linkSignature"
                  style="width: 150px; height: 150px; display: inline-block"
                />
                <img
                  v-else
                  src="./img/signature.png"
                  style="width: 150px; height: 150px; display: inline-block"
                />
                <br />
                <strong>{{ dataContract.name }}</strong>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { AgentService } from '@/services/agent.service'

  export default {
    data() {
      return {
        agentId: this.$route.query.agentId,
        dataContract: {},
      }
    },

    created() {
      this.fetchData()
    },

    methods: {
      async fetchData() {
        try {
          const response = await AgentService.getOneAgent({
            agentId: this.agentId,
          })
          if (response.code === 1000) {
            this.dataContract = response.data
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>

<style scoped>
  @font-face {
    font-family: 'Roboto-Bold' !important;
    src: url('./fonts/Roboto-Bold.ttf') !important;
  }

  @font-face {
    font-family: 'Roboto-Italic' !important;
    src: url('./fonts/Roboto-Italic.ttf') !important;
  }

  @font-face {
    font-family: 'Roboto-Medium' !important;
    src: url('./fonts/Roboto-Medium.ttf') !important;
  }

  @font-face {
    font-family: 'Roboto-Regular' !important;
    src: url('./fonts/Roboto-Regular.ttf') !important;
  }

  html {
    font-family: 'Roboto-Regular' !important;
  }

  body {
    font-family: 'Roboto-Regular' !important;
    color: #3e4348 !important;
  }

  .font-bold {
    font-family: 'Roboto-Bold' !important;
  }

  .font-italic {
    font-family: 'Roboto-Italic' !important;
  }

  .font-medium {
    font-family: 'Roboto-Medium' !important;
  }

  .font-regular {
    font-family: 'Roboto-Regular' !important;
  }

  ol,
  ul {
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    font-size: 100% !important;
    font: inherit !important;
    vertical-align: baseline !important;
  }

  li {
    list-style: none !important;
  }

  pre {
    color: #121212 !important;
  }

  a {
    text-decoration: none !important;
  }

  a:hover {
    text-decoration: none !important;
  }

  a:focus,
  a:active,
  a:hover,
  a:visited {
    outline: none !important;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    margin: 0 !important;
  }

  h1.light,
  h2.light,
  h3.light,
  h4.light,
  h5.light {
    font-family: 'Roboto-Bold' !important;
    font-weight: initial !important;
  }

  h1,
  .h1 {
    font-size: 45px !important;
    margin-top: 0 !important;
  }

  div,
  p,
  span {
    text-align: left !important;
  }

  h2,
  .h2 {
    font-size: 25px !important;
  }

  h3 {
    font-size: 20px !important;
  }

  strong,
  label {
    /*  font-family: 'Roboto-Medium';*/
    /*margin: 0;*/
  }

  p {
    line-height: 23px !important;
    margin-bottom: 0 !important;
  }

  button,
  a {
    outline: none !important;
  }

  button {
    font-family: 'Roboto-Medium' !important;
  }

  .btn:focus,
  .btn.focus,
  button:focus,
  button.focus {
    outline: 0 !important;
    box-shadow: none !important;
  }

  td,
  th {
    vertical-align: middle !important;
  }

  .table td,
  .table th {
    padding: 8px 10px !important;
  }

  input {
    outline: none !important;
    box-shadow: none !important;
  }

  input:focus {
    border-color: #006ee3 !important;
  }

  img {
    max-width: 100% !important;
    max-height: 100% !important;
  }

  td {
    vertical-align: middle !important;
  }

  .p-0 {
    padding: 0 !important;
  }

  .p-10 {
    padding: 10px !important;
  }

  .p-t-0 {
    padding-top: 0 !important;
  }

  .p-b-0 {
    padding-bottom: 0 !important;
  }

  .p-l-0 {
    padding-left: 0 !important;
  }

  .p-r-0 {
    padding-right: 0 !important;
  }

  .p-t-10 {
    padding-top: 10px !important;
  }

  .p-b-10 {
    padding-bottom: 10px !important;
  }

  .p-l-10 {
    padding-left: 10px !important;
  }

  .p-r-10 {
    padding-right: 10px !important;
  }

  .p-t-20 {
    padding-top: 20px !important;
  }

  .p-b-20 {
    padding-bottom: 20px !important;
  }

  .p-b-50 {
    padding-bottom: 50px !important;
  }

  .p-l-20 {
    padding-left: 20px !important;
  }

  .p-l-30 {
    padding-left: 30px !important;
  }

  .p-r-20 {
    padding-right: 20px !important;
  }

  .p-r-30 {
    padding-right: 30px !important;
  }

  .pt-15 {
    padding: 15px 0px 0px !important;
  }

  .pl-15 {
    padding-left: 15px !important;
  }

  .m-0 {
    margin: 0 !important;
  }

  .m-0-auto {
    margin: 0 auto !important;
  }

  .m-b-0 {
    margin-bottom: 0 !important;
  }

  .m-t-0 {
    margin-top: 0 !important;
  }

  .m-l-0 {
    margin-left: 0 !important;
  }

  .m-r-0 {
    margin-right: 0 !important;
  }

  .m-r-10 {
    margin-right: 10px !important;
  }

  .m-t-10 {
    margin-top: 10px !important;
  }

  .m-t-50 {
    margin-top: 50px !important;
  }

  .m-t-80 {
    margin-top: 80px !important;
  }

  .m-t-100 {
    margin-top: 100px !important;
  }

  .m-t-20 {
    margin-top: 20px !important;
  }

  .m-t-28 {
    margin-top: 28px !important;
  }

  .m-t-30 {
    margin-top: 30px !important;
  }

  .m-t-36 {
    margin-top: 36px !important;
  }

  .m-b-5 {
    margin-bottom: 5px !important;
  }

  .m-b-10 {
    margin-bottom: 10px !important;
  }

  .m-b-15 {
    margin-bottom: 15px !important;
  }

  .m-b-20 {
    margin-bottom: 20px !important;
  }

  .m-b-30 {
    margin-bottom: 30px !important;
  }

  .m-b-40 {
    margin-bottom: 40px !important;
  }

  .m-b-50 {
    margin-bottom: 50px !important;
  }

  .m-b-60 {
    margin-bottom: 60px !important;
  }

  .m-b-70 {
    margin-bottom: 70px !important;
  }

  .m-b-80 {
    margin-bottom: 80px !important;
  }

  .m-b-90 {
    margin-bottom: 90px !important;
  }

  .m-b-100 {
    margin-bottom: 100px !important;
  }

  .m-0 {
    margin: 0 !important;
  }

  .m-l-0 {
    margin-left: 0 !important;
  }

  .m-l-10 {
    margin-left: 10px !important;
  }

  .m-r-0 {
    margin-right: 0 !important;
  }

  .m-r-20 {
    margin-right: 20px !important;
  }

  .m-t--70 {
    margin-top: -70px;
  }

  .text-transform {
    text-transform: uppercase !important;
  }

  .text-transform-none {
    text-transform: initial !important;
  }

  .b-r-5 {
    border-radius: 5px !important;
  }

  .border-fff {
    border-color: #fff !important;
  }

  .border-trans {
    border-color: transparent !important;
  }

  .b-t-das {
    border-top: 1px dashed #e8ebf1 !important;
  }

  .b-0 {
    border: 0 !important;
  }

  .b-b-0 {
    border-bottom: 0 !important;
  }

  .b-t-0 {
    border-top: 0 !important;
  }

  .b-l-0 {
    border-left: 0 !important;
  }

  .b-r-0 {
    border-right: 0 !important;
  }

  .b-b-1-869fb229 {
    border-bottom: 1px solid #869fb229 !important;
  }

  .b-t-1-869fb229 {
    border-top: 1px solid #869fb229 !important;
  }

  .b-t-2-869fb229 {
    border-top: 2px solid #869fb229 !important;
  }

  .b-l-1-869fb229 {
    border-left: 1px solid #869fb229 !important;
  }

  .b-r-1-869fb229 {
    border-right: 1px solid #869fb229 !important;
  }

  .b-1-869fb229 {
    border: 1px solid #869fb229 !important;
  }

  .boder-fff-2 {
    border: 2px solid #fff !important;
  }

  .pos-absolute {
    position: absolute !important;
  }

  .pos-relative {
    position: relative !important;
  }

  .top-0 {
    top: 0 !important;
  }

  .left-0 {
    left: 0 !important;
  }

  .right-0 {
    right: 0 !important;
  }

  .bottom-0 {
    bottom: 0 !important;
  }

  .width-10 {
    width: 10% !important;
  }

  .width-20 {
    width: 20% !important;
  }

  .width-30 {
    width: 30% !important;
  }

  .width-40 {
    width: 40% !important;
  }

  .width-50 {
    width: 50% !important;
  }

  .width-60 {
    width: 60% !important;
  }

  .width-70 {
    width: 70% !important;
  }

  .width-80 {
    width: 80% !important;
  }

  .width-90 {
    width: 90% !important;
  }

  .width-100 {
    width: 100% !important;
  }

  .wd-150 {
    width: 150px !important;
  }

  .wd-200 {
    width: 200px !important;
  }

  .wd-300 {
    width: 300px !important;
  }

  .width-auto {
    width: auto !important;
  }

  .f12 {
    font-size: 12px !important;
  }

  .f14 {
    font-size: 14px !important;
  }

  .f16 {
    font-size: 16px !important;
  }

  .f18 {
    font-size: 18px !important;
  }

  .f20 {
    font-size: 20px !important;
  }

  .f30 {
    font-size: 30px !important;
  }

  .height-40vh {
    height: 40vh !important;
  }

  .height-400 {
    height: 400px !important;
  }

  .transfor_rotate_-90 {
    -ms-transform: rotate(-90deg) !important;
    -webkit-transform: rotate(-90deg) !important;
    transform: rotate(-90deg) !important;
  }

  .transfor_rotate_90 {
    -ms-transform: rotate(90deg) !important;
    -webkit-transform: rotate(90deg) !important;
    transform: rotate(90deg) !important;
  }

  .transfor_rotate_-180 {
    -ms-transform: rotate(-180deg) !important;
    -webkit-transform: rotate(-180deg) !important;
    transform: rotate(-180deg) !important;
  }

  .transfor_rotate_180 {
    -ms-transform: rotate(180deg) !important;
    -webkit-transform: rotate(180deg) !important;
    transform: rotate(180deg) !important;
  }

  .display-none {
    display: none !important;
  }

  .display-inlineblock {
    display: inline-block !important;
  }

  .display-block {
    display: block !important;
  }

  .prepend-icon {
    position: relative !important;
  }

  .prepend-icon i {
    color: #1b1e25 !important;
    color: rgba(27, 30, 37, 0.7) !important;
    font-size: 18px !important;
    height: 34px !important;
    right: 0px !important;
    line-height: 34px !important;
    position: absolute !important;
    text-align: center !important;
    top: 0 !important;
    width: 36px !important;
  }

  .height-combox {
    height: 37px !important;
  }

  .pull-left {
    float: left !important;
  }

  .pull-right {
    float: right !important;
  }

  ::-webkit-scrollbar {
    width: 6px !important;
    height: 6px !important;
  }

  ::-webkit-scrollbar:hover {
    width: 5px !important;
    height: 5px !important;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888 !important;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555 !important;
    transform: all 1s ease !important;
  }

  .title-all {
    font-size: 18px !important;
    font-family: 'Roboto-Medium' !important;
  }

  /*Button*/
  .base-btn {
    border-radius: 4px !important;
    border: 0 !important;
  }

  .basic-btn {
    background: #006ee3 !important;
    border: 1px solid #006ee3 !important;
    color: #fff !important;
    transition: all 0.5s ease !important;
  }

  .basic-btn:hover {
    background: #007cff !important;
    border: 1px solid #007cff !important;
  }

  .outline-btn {
    background: #fff !important;
    border: 1px solid #006ee3 !important;
    color: #006ee3 !important;
    transition: all 0.5s ease !important;
  }

  .outline-btn:hover {
    border: 1px solid #006ee3 !important;
    background: #e5f0fc !important;
  }

  .default-btn {
    background: #e5f0fc !important;
    border: 1px solid #e5f0fc !important;
    color: #006ee3 !important;
    transition: all 0.5s ease !important;
  }

  .default-btn:hover {
    border: 1px solid #c1dfff !important;
    background: #c1dfff !important;
  }

  .bb-sm {
    height: 40px !important;
    font-size: 14px !important;
  }

  .bb-lg {
    height: 50px !important;
    font-size: 16px !important;
  }

  /*End Button*/

  /*Form*/

  .form-search {
    position: relative !important;
  }

  .form-search input {
    height: 40px !important;
    border: 1px solid #d5d8db !important;
    border-radius: 4px !important;
    padding-left: 35px !important;
    font-size: 14px !important;
  }

  .form-search input::placeholder {
    color: #c4c4c4 !important;
    font-size: 14px !important;
  }

  .form-search span {
    display: inline-block !important;
    position: absolute !important;
    top: 9px !important;
    left: 8px !important;
  }

  .form-search span i {
    font-size: 24px !important;
    color: #c4c4c4 !important;
  }

  .list-form {
  }

  .list-form .form-group {
    position: relative !important;
  }

  .list-form .form-group label {
    font-size: 14px !important;
    font-family: 'Roboto-Medium' !important;
  }

  .list-form .form-group input {
    height: 40px !important;
    font-size: 16px !important;
    color: #3e4348 !important;
    transition: all 0.5s ease !important;
  }

  .list-form .form-group input::placeholder {
    font-size: 14px !important;
    color: #c4c4c4 !important;
  }

  .list-form .form-group input:focus {
    color: #006ee3 !important;
    border-color: #006ee3 !important;
    font-family: 'Roboto-Medium' !important;
  }

  .list-form .form-group.form-erross input {
    border-color: #e1000a !important;
    color: #e1000a !important;
  }

  .list-form .form-group small.text-erross {
    display: none !important;
    color: #e1000a !important;
  }

  .list-form .form-group.form-erross small.text-erross {
    display: block !important;
  }

  .list-form .form-group span.img-cvv {
    position: absolute !important;
    right: 7px !important;
    bottom: 10px !important;
  }

  /*switch*/
  .switch {
    position: relative !important;
    display: block !important;
    width: 34px !important;
    height: 20px !important;
  }

  .switch input {
    opacity: 0 !important;
    width: 0 !important;
    height: 0 !important;
  }

  .slider {
    position: absolute !important;
    cursor: pointer !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    background-color: #ccc !important;
    -webkit-transition: 0.4s !important;
    transition: 0.4s !important;
  }

  .slider:before {
    position: absolute !important;
    content: '' !important;
    height: 18px !important;
    width: 18px !important;
    left: 1px !important;
    bottom: 1px !important;
    background-color: white !important;
    -webkit-transition: 0.4s !important;
    transition: 0.4s !important;
  }

  input:checked + .slider {
    background-color: #2f6bff !important;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #2f6bff !important;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(14px) !important;
    -ms-transform: translateX(14px) !important;
    transform: translateX(14px) !important;
  }

  .slider.round {
    border-radius: 34px !important;
  }

  .slider.round:before {
    border-radius: 50% !important;
  }

  /* End switch */
  /* Style Radio */
  .container-radio {
    display: block !important;
    position: relative !important;
    padding-left: 35px !important;
    margin-bottom: 12px !important;
    cursor: pointer !important;
    font-size: 14px !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    user-select: none !important;
  }

  .container-radio input {
    position: absolute !important;
    opacity: 0 !important;
    cursor: pointer !important;
  }

  .radiomark {
    position: absolute !important;
    top: -2px !important;
    left: 0 !important;
    height: 20px !important;
    width: 20px !important;
    background-color: #fff !important;
    border-radius: 50% !important;
    border: 3px solid #bcc0c5 !important;
  }

  .container-radio:hover input ~ .radiomark {
    background-color: #ccc !important;
  }

  .container-radio input:checked ~ .radiomark {
    background-color: #2f6bff !important;
    border: 0 !important;
  }

  .radiomark:after {
    content: '' !important;
    position: absolute !important;
    display: none !important;
  }

  .container-radio input:checked ~ .radiomark:after {
    display: block !important;
  }

  .container-radio .radiomark:after {
    top: 4px !important;
    left: 4px !important;
    width: 12px !important;
    height: 12px !important;
    border-radius: 50% !important;
    background: white !important;
  }

  /* End Style radio */

  /*Style check*/
  .container-check {
    display: block !important;
    position: relative !important;
    padding-left: 35px !important;
    margin-bottom: 12px !important;
    cursor: pointer !important;
    font-size: 14px !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    user-select: none !important;
  }

  .container-check input {
    position: absolute !important;
    opacity: 0 !important;
    cursor: pointer !important;
    height: 0 !important;
    width: 0 !important;
  }

  .checkmark {
    position: absolute !important;
    top: -2px !important;
    left: 0 !important;
    height: 20px !important;
    width: 20px !important;
    background-color: #fff !important;
    border-radius: 4px !important;
    border: 3px solid #bcc0c5 !important;
  }

  .container-check:hover input ~ .checkmark {
    background-color: #ccc !important;
  }

  .container-check input:checked ~ .checkmark {
    background-color: #2f6bff !important;
    border: 0 !important;
  }

  .checkmark:after {
    content: '' !important;
    position: absolute !important;
    display: none !important;
  }

  .container-check input:checked ~ .checkmark:after {
    display: block !important;
  }

  .container-check .checkmark:after {
    left: 7px !important;
    top: 3px !important;
    width: 6px !important;
    height: 11px !important;
    border: solid white !important;
    border-width: 0px 2px 2px 0px !important;
    -webkit-transform: rotate(45deg) !important;
    -ms-transform: rotate(45deg) !important;
    transform: rotate(45deg) !important;
  }

  /*End stylecheck*/

  .dropdown-toggle.inv-dropdown {
    background-color: #fff !important;
    border: 1px solid #ced4da !important;
    border-radius: 4px !important;
    height: 40px !important;
    font-size: 14px !important;
    color: #2a2a2a !important;
    padding: 0 20px 0 8px !important;
    position: relative !important;
    width: 100% !important;
    text-align: left !important;
  }

  .dropdown-toggle.inv-dropdown:focus {
    box-shadow: none !important;
  }

  .caret {
    border-color: #888 transparent transparent transparent !important;
    border-style: solid !important;
    border-width: 5px 4px 0 4px !important;
    height: 0 !important;
    position: absolute !important;
    top: 14px !important;
    width: 0 !important;
    right: 6px !important;
    color: #fff !important;
  }

  .dropdown-toggle::after {
    position: absolute !important;
    right: 10px !important;
    top: 17px !important;
  }

  .dropdown-style .dropdown-menu {
    background-color: white !important;
    width: 100% !important;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2) !important;
    border: none !important;
    /*margin-top: 38px !important;;*/
    padding-left: 0 !important;
    padding-top: 0 !important;
  }

  .dropdown-style .dropdown-menu #myInput {
    background: #fff !important;
    padding: 8px 10px !important;
    height: auto !important;
    border: 0 !important;
  }

  .option-toggle {
    border: 2px solid #aeb1b5 !important;
    background-color: #fff !important;
    position: relative !important;
    display: inline-block !important;
    cursor: pointer !important;
    flex: 0 0 16px !important;
    border-radius: 50% !important;
    height: 16px !important;
    width: 16px !important;
    margin-right: 10px !important;
  }

  .option-toggle input {
    cursor: pointer !important;
    position: absolute !important;
    top: -2px !important;
    left: -20000px !important;
  }

  .selected .option-toggle {
    border: 5px solid #2996cc !important;
  }

  .dropdown-style .dropdown-menu li a {
    display: flex !important;
    font-size: 14px !important;
    color: #343b42 !important;
    align-items: center !important;
    padding: 5px 10px !important;
  }

  .iv-search {
    display: flex !important;
    border-bottom: 1px solid #bcc1c7 !important;
    margin-bottom: 10px !important;
  }

  .iv-search svg {
    width: 20px !important;
    margin-left: 10px !important;
    height: 20px !important;
    margin-top: 10px !important;
  }

  .iv-search svg path {
    fill: #bcc1c7 !important;
  }

  .list-link .icon {
    width: 20px !important;
    height: 20px !important;
    border-radius: 50% !important;
    display: flex !important;
    text-align: center !important;
    color: #fff !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 10px !important;
  }

  .radios {
    position: relative !important;
    cursor: pointer !important;
    width: 100% !important;
    padding-left: 10px !important;
    font-size: 14px !important;
  }

  .radios .label {
    position: relative !important;
    display: block !important;
    float: left !important;
    margin-right: 10px !important;
    width: 18px !important;
    height: 18px !important;
    border: 2px solid #aeb1b5 !important;
    border-radius: 100% !important;
    -webkit-tap-highlight-color: transparent !important;
  }

  .radios:hover .label:after {
    transform: scale(3.6) !important;
  }

  input[type='radio']:checked + .label {
    border: 5px solid #2996cc !important;
  }

  input[type='radio']:checked + .label:after {
    transform: scale(1) !important;
    transition: all 0.2s cubic-bezier(0.35, 0.9, 0.4, 0.9) !important;
    opacity: 1 !important;
  }

  .hidden {
    display: none !important;
  }

  @media (max-width: 576px) {
    .boxcont {
      padding: 0 40px 0 30px !important;
      margin-top: 30px !important;
    }

    .drag {
      left: 5px !important;
    }
  }

  /*End Form*/
  /* Alert */
  .alert-warning {
    color: #856404 !important;
    background-color: #fff3cd !important;
    border-color: #ffeeba !important;
  }

  .alert-dismissible {
    padding-right: 4rem !important;
  }

  .alert {
    position: relative !important;
    padding: 9px 50px 9px 35px !important;
    margin-bottom: 1rem !important;
    border: 1px solid transparent !important;
    border-radius: 4px !important;
    font-size: 14px !important;
  }

  .fade {
    transition: opacity 0.15s linear !important;
  }

  .alert-dismissible .close {
    position: absolute !important;
    top: 0 !important;
    right: 0 !important;
    padding: 9px 15px !important;
    color: inherit !important;
  }

  .bd-example::after {
    display: block !important;
    clear: both !important;
    content: '' !important;
  }

  .close {
    float: right !important;
    font-size: 1.5rem !important;
    font-weight: normal !important;
    line-height: 1 !important;
    color: #000 !important;
    text-shadow: 0 1px 0 #fff !important;
    opacity: 0.5 !important;
  }

  .alert-edit strong {
  }

  .alert-edit strong i {
    font-size: 20px !important;
    position: absolute !important;
    left: 8px !important;
    top: 8px !important;
  }

  .alert-edit.alert-warning strong i {
    color: #e28d1e !important;
  }

  .alert-edit.alert-primary strong i {
    color: #006ee3 !important;
  }

  .alert-edit.alert-danger strong i {
    color: #e1000a !important;
  }

  .alert-edit.alert-warning {
    background-color: #ffecd2 !important;
  }

  .alert-edit.alert-primary {
    background-color: #e5f0fc !important;
  }

  .alert-edit.alert-danger {
    background-color: #ffcbcd !important;
  }

  .icon-form {
    position: absolute !important;
    display: inline-block !important;
    right: 10px !important;
    bottom: 10px !important;
  }

  .icon-form i {
    font-size: 20px !important;
  }

  .form-card {
  }

  .form-card label {
  }

  .form-card .form-input {
    position: relative !important;
  }

  .form-card .form-input input {
  }

  .form-card .form-input input:nth-child(1) {
    border-radius: 4px 4px 0 0 !important;
  }

  .form-card .form-input input:nth-child(2) {
    width: 50% !important;
    float: left !important;
    border-top: 1px solid #fff !important;
    border-radius: 0 0 0 4px !important;
    border-right: 1px solid #fff !important;
  }

  .form-card .form-input input:nth-child(3) {
    width: 50% !important;
    border-top: 1px solid #fff !important;
    border-radius: 0 0 4px 0 !important;
  }

  .form-card .form-input input:nth-child(2):focus {
    border-top: 1px solid #006ee3 !important;
    border-right: 1px solid #006ee3 !important;
  }

  .form-card .form-input input:nth-child(3):focus {
    border-top: 1px solid #006ee3 !important;
  }

  .form-card .form-input ul.fi-img {
    position: absolute !important;
    right: 5px !important;
  }

  .form-card .form-input li {
    width: 32px !important;
    float: left !important;
    margin-right: 2px !important;
  }

  .form-card .form-input li img {
    width: 100% !important;
  }

  .form-card .form-input ul.fi-img.fi-card {
    top: 7px !important;
  }

  .form-card .form-input ul.fi-img.fi-cvv {
    bottom: 8px !important;
  }

  /*Header*/
  .header {
    background: #1765aa !important;
    position: relative !important;
  }

  .header-before:before {
    content: '' !important;
    position: absolute !important;
    left: 0 !important;
    right: 0 !important;
    background: #1765aa !important;
    width: 100% !important;
    height: 209px !important;
    top: 50px !important;
    z-index: -1 !important;
  }

  .logo {
    text-align: center !important;
    width: auto !important;
    padding: 15px 0 !important;
  }

  .logo a {
    display: inline-block !important;
    width: 130px !important;
  }

  .logo a img {
  }

  .logo h1 {
    color: #fff !important;
    margin-top: 16px !important;
    font-size: 24px !important;
    /*font-family: 'Roboto-Medium'*/
  }

  /*End Header*/

  /*Main*/
  .main {
    max-width: 800px !important;
    margin: 0 auto !important;
    background: #fff !important;
    border-radius: 5px !important;
    box-shadow: 0 0px 32px rgba(0, 0, 0, 0.06) !important;
  }

  .title-main {
    /*padding: 15px !important;*/
    position: relative !important;
    background-image: linear-gradient(white, #e1e1e1) !important;
    border-radius: 5px 5px 0 0 !important;
  }

  .title-main .nav-tabs {
    display: inline-block !important;
    width: 100% !important;
    padding: 16px 15px !important;
  }

  .title-main .nav-tabs .nav-item {
    /*width: 100% !important;*/
    float: left !important;
  }

  .title-main .nav-tabs .nav-item .nav-link {
    display: block !important;
    border: 0 !important;
    border-radius: 0 !important;
    padding: 0 !important;
    /* margin-bottom: 15px !important; */
    line-height: 24px !important;
    font-size: 12px !important;
    color: #333 !important;
    font-family: 'Roboto-Medium' !important;
    /*text-transform: uppercase !important;*/
    border: 1px solid #dcdcdc !important;
    padding: 4px 10px !important;
    background: #fff !important;
    border-radius: 25px !important;
  }

  .title-main .nav-tabs .nav-item .nav-link span {
    display: inline-block !important;
    margin-right: 5px !important;
  }

  .btn .bx {
    font-size: 18px !important;
    vertical-align: text-bottom !important;
  }

  .title-main .nav-tabs .nav-item .nav-link:hover {
  }

  .title-main .nav-tabs .nav-item .nav-link.active {
    display: none !important;
  }

  .list-btn {
    position: absolute !important;
    top: 12px !important;
    right: 15px !important;
    width: auto !important;
  }

  .list-btn button,
  .list-btn a {
    margin-left: 10px !important;
  }

  /*.form-detail{
    border: 1px solid #dcdcdc !important;
    padding: 10px 15px !important;
    border-radius: 4px !important;
    margin-bottom: 15px !important;
}*/
  .form-detail h1 {
    font-size: 14px !important;
    padding-bottom: 5px !important;
    border-bottom: 1px solid #dcdcdc !important;
    margin-bottom: 10px !important;
  }

  .form-detail .form-group {
    margin-bottom: 5px !important;
  }

  .form-detail .form-group:last-child {
    margin-bottom: 0px !important;
  }

  .form-detail .form-group label,
  .form-detail .form-group p.form-control-plaintext {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 12px !important;
  }

  .form-success {
    text-align: center !important;
  }

  .form-success span {
    font-size: 100px !important;
    margin-bottom: 10px !important;
    display: inline-block !important;
    color: #4caf50 !important;
  }

  .form-success h1 {
  }

  .main-content {
    padding: 15px !important;
    background: #fafafa !important;
  }

  .box-detail table td,
  .box-detail table th {
    font-size: 12px !important;
  }

  .old-price {
    text-decoration: line-through !important;
    color: #a1a1a1 !important;
  }

  .new-price {
    color: #ff0000 !important;
  }

  .box-title {
    margin-bottom: 10px !important;
  }

  .box-title h3 {
    font-size: 14px !important;
  }

  .box-content {
    background: #fff !important;
    border-radius: 5px !important;
    padding: 10px !important;
    font-size: 12px !important;
  }

  /*-----hợp đồng-----*/
  .contract {
    max-width: 980px !important;
    margin: 0 auto !important;
    font-size: 14px !important;
  }

  .contract p {
    margin: 5px 0 !important;
  }

  .txt-center {
    text-align: center !important;
  }

  .txt-bold {
    font-weight: bold !important;
  }

  .fonsize-16 {
    font-size: 16px !important;
  }

  .fonsize-20 {
    font-size: 20px !important;
  }

  .fonsize-12 {
    font-size: 12px !important;
  }

  .contract {
    padding: 15px !important;
    background: #fff !important;
    border: 1px solid #eeeded !important;
    box-shadow: 0 0px 32px rgba(0, 0, 0, 0.06) !important;
  }

  .contract ol {
    counter-reset: item !important;
    /*list-style-type: none !important;*/
    padding: 0 !important;
    padding-left: 20px !important;
  }

  .contract li {
    margin-bottom: 10px !important;
    line-height: 18px !important;
    list-style: inherit !important;
  }

  .contract ol li ol {
    list-style-type: none !important;
    padding-left: 60px !important;
  }

  .contract ol li ol li {
    position: relative !important;
  }

  .contract ol li:before {
    content: counters(item, '.') ' ' !important;
    counter-increment: item !important;
    font-weight: bold !important;
    color: #fff !important;
  }

  .contract li ol li::before {
    color: #000 !important;
    position: absolute !important;
    left: -30px !important;
  }

  .contract li ol li ol li::before {
    font-weight: normal !important;
    margin-right: 5px !important;
    color: #000 !important;
  }

  .contract ol li ul {
    list-style-type: lower-alpha !important;
    margin-top: 10px !important;
    padding-left: 0 !important;
    margin-left: -15px !important;
  }

  .contract ol li ul li {
    padding-left: 16px !important;
  }

  .contract ol li ul li::before {
    counter-increment: inherit !important;
    content: normal !important;
  }

  .contract h1 {
    counter-reset: subsection !important;
    font-size: 14px !important;
    display: inline-block !important;
    margin: 0 0 10px !important;
  }

  .contract .paddL20 {
    padding-left: 20px !important;
  }

  .txt-tranf {
    text-transform: uppercase !important;
  }

  .contract .form-control {
    border: 0 !important;
    border-bottom: 1px dashed #000 !important;
    border-radius: 0 !important;
    padding: 0 10px !important;
    color: #000 !important;
    font-size: 14px !important;
  }

  .contract .form-control:focus {
    outline: none !important;
  }

  .contract .form-style {
    list-style-type: lower-alpha !important;
    font-style: italic !important;
    margin-bottom: 30px !important;
    padding-left: 40px !important;
  }

  .contract h3 {
    font-style: italic !important;
    font-weight: bold !important;
    font-size: 14px !important;
    margin: 0 0 10px !important;
  }

  .contract ul.form {
    list-style: none !important;
    padding: 0 !important;
    display: flex !important;
    flex-wrap: wrap !important;
    width: 70% !important;
  }

  .contract ul.form li {
    width: 50% !important;
  }

  .contract .w50 {
    width: 50px !important;
  }

  .contract .w100 {
    width: 100% !important;
  }

  .magb20 {
    margin-bottom: 20px !important;
  }

  .magb10 {
    margin-bottom: 10px !important;
  }

  .magt10 {
    margin-top: 10px !important;
  }

  .contract .clred {
    color: red !important;
  }

  .contract .flex {
    display: flex !important;
  }

  .contract .form-style1 li::before {
    margin-left: -8px !important;
  }

  .contract .form-style1 h1 {
    text-transform: uppercase !important;
    font-size: 16px !important;
    /*text-decoration: underline !important;*/
    font-family: 'Roboto-Medium' !important;
  }

  .contract .form-style1 .form-style {
    font-style: normal !important;
    padding-left: 35px !important;
  }

  .contract .form-style1 li ol li ul {
    padding-left: 0 !important;
  }

  .contract .form-style1 li ul {
    padding-left: 44px !important;
  }

  .contract .form-style1 li ul li ol,
  .contract .form-style2,
  .contract ol li ul.form-style2 {
    padding-left: 10px !important;
    margin-top: 10px !important;
    list-style-type: '-' !important;
  }

  .contract ol li ul.form-style2 {
    margin: 0 !important;
  }

  .contract ol.form-style2 li:before {
    content: none !important;
  }

  .contract ol.form-style2 li {
    padding-left: 10px !important;
  }

  .contract .form-style1 li ul li ol li {
    padding-left: 15px !important;
  }

  .contract table {
    border-collapse: collapse !important;
    border-top: 1px solid #000 !important;
    border-left: 1px solid #000 !important;
    width: 100% !important;
    margin-bottom: 10px !important;
  }

  .contract table td,
  .contract table th {
    border-bottom: 1px solid #000 !important;
    border-right: 1px solid #000 !important;
    padding: 10px 5px !important;
  }

  .contract .bg-head {
    background: #9bc2e6 !important;
  }

  .contract .bg-head1 {
    background: #fabf8f !important;
  }

  .contract table th {
    text-align: center !important;
  }

  .contract .nowrap {
    white-space: nowrap !important;
  }

  @media (max-width: 768px) {
    .contract .nowrap {
      white-space: normal !important;
    }
  }

  .contract mark {
    margin: 0 5px !important;
    padding: 0 5px !important;
    background-color: #ffe34d !important;
  }

  .contract .form-style3 {
    list-style-type: none !important;
    padding-left: 12px !important;
  }

  .contract .form-style3 li::before {
    content: '✓' !important;
    color: #000 !important;
    position: absolute !important;
    left: 4px !important;
    margin-left: 0 !important;
  }

  .contract .form-style3 li {
    padding-left: 30px !important;
    position: relative !important;
  }

  .contract .txt-under {
    text-decoration: underline !important;
  }

  .form-detail {
    border: 1px solid #eeeded !important;
    padding: 10px 15px !important;
    border-radius: 4px !important;
    margin-bottom: 15px !important;
    box-shadow: 0 0px 32px rgba(0, 0, 0, 0.06) !important;
  }

  .form-detail h1 {
    font-size: 16px !important;
    padding-bottom: 5px !important;
    border-bottom: 1px solid #dcdcdc !important;
    margin-bottom: 10px !important;
  }

  .form-detail .form-group {
    margin-bottom: 5px !important;
  }

  .form-detail .form-group:last-child {
    margin-bottom: 0px !important;
  }

  .form-detail .form-group label,
  .form-detail .form-group p.form-control-plaintext {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .head-contract {
  }

  .head-contract table {
    border: 0 !important;
    margin-bottom: 30px !important;
  }

  .head-contract table tr td {
    border: 0 !important;
    border-bottom: 2px solid #dcdcdc !important;
  }

  .head-contract table tr td label {
    font-size: 14px !important;
    font-family: 'Roboto-Medium' !important;
    margin: 0 !important;
  }

  .head-contract table tr td p {
    font-size: 12px !important;
    margin: 0 !important;
    line-height: 18px !important;
  }

  /*End hợp đồng*/

  .main-button {
  }

  .main-button ul {
    display: flex !important;
    margin: 0 -5px !important;
  }

  .main-button ul li {
    display: flex !important;
    width: 50% !important;
    padding: 0 5px !important;
  }

  .main-button ul li a {
    color: #fff !important;
    width: 100% !important;
  }

  .tab-child-list {
    max-width: 500px !important;
    margin: 10px auto 20px !important;
    border: 1px solid #eaeaea !important;
    border-radius: 5px !important;
    /* -webkit-box-shadow: 0px 1px 16px -8px rgba(0,0,0,0.25) !important; */
    -moz-box-shadow: 0px 1px 16px -8px rgba(0, 0, 0, 0.25) !important;
    box-shadow: 0px 1px 16px -8px rgba(0, 0, 0, 0.25) !important;
    justify-content: space-around !important;
    background: #fff !important;
  }

  .tab-child-list li {
    /*width: 33.33% !important;*/
    text-align: center !important;
    margin: 0 !important;
    padding: 0 5px !important;
  }

  .tab-child-list li a {
    border: 0 !important;
    color: #333 !important;
    font-family: 'Roboto-Medium' !important;
    padding: 10px 5px !important;
    font-size: 12px !important;
  }

  .tab-child-list li a.active,
  .tab-child-list li a:hover {
    border: 0 !important;
    color: #1765aa !important;
    position: relative !important;
  }

  .tab-child-list li a.active:before,
  .tab-child-list li a:hover:before {
    width: 100% !important;
    position: absolute !important;
    content: '' !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    height: 4px !important;
    background: #1765aa !important;
    border-radius: 10px 10px 0px 0px !important;
  }

  .tab-child-content {
  }

  /*End Main*/

  /*Footer*/
  footer {
    margin-top: 30px !important;
  }

  .footer-title p {
    font-size: 12px !important;
    color: #848484 !important;
    /* font-family: 'Roboto-Bold' !important; */
    display: inline-block !important;
    margin-bottom: 0 !important;
    line-height: 18px !important;
    text-align: center !important;
    width: 100% !important;
  }

  .footer-title a {
    display: inline-block !important;
    width: 64px !important;
  }

  .footer-title p a img {
    vertical-align: text-bottom !important;
  }

  .footer-about {
    margin: 5px 0 !important;
  }

  .footer-about p {
    color: #848484 !important;
    font-size: 11px !important;
    margin-bottom: 8px !important;
    line-height: 12px !important;
    text-align: center !important;
  }

  .footer-about p b a {
    color: #848484 !important;
  }

  .footer-logo {
    padding: 0 !important;
    margin: 0 !important;
    text-align: center !important;
  }

  .footer-logo li {
    list-style: none !important;
    display: inline-block !important;
    margin: 0 3px !important;
  }

  .footer-logo li a {
    display: inherit !important;
    height: 24px !important;
    filter: grayscale(100%) !important;
    opacity: 0.5 !important;
  }

  .footer-logo li a img {
    max-width: 100% !important;
    max-height: 100% !important;
  }

  .dk-list,
  .dk-list li {
    list-style: none !important;
  }

  /*End Footer*/
  /*Modal Bieu phi*/
  .modal-dialog {
    max-width: 60%;
    overflow-x: auto;
    margin: 0 auto;
  }

  .modal-body {
    width: 100%;
  }

  @media screen and (max-width: 410px) {
    .modal-dialog {
      margin: 0 7%;
      max-width: 76%;
    }
  }
</style>
